import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";

const TwoUpFeaturedCard = ({ twoUpFeaturedCardData = {} }) => {
  const { heading = "", images = [] } = twoUpFeaturedCardData;

  return (
    <div className={styles.container}>
      {heading && <p className={styles.heading}>{heading}</p>}
      <div className={styles.grid}>
        {images?.map(
          (
            { fields: { imageUrl = "", title = "", cta = {} } = {} } = {},
            index
          ) => {
            const { label = "", url = "", mediaUrl = "" } = cta?.fields || {};
            return (
              <div key={index} className={styles.card}>
                <img src={imageUrl} alt={title} />

                <div className={styles.overlay}>
                  <h3>{title}</h3>
                  <a href={url || mediaUrl} className={styles.cta}>
                    {label}
                  </a>
                </div>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
};

TwoUpFeaturedCard.propTypes = {
  twoUpFeaturedCardData: PropTypes.shape({
    heading: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.string,
        title: PropTypes.string,
      })
    ),
  }),
};

export default TwoUpFeaturedCard;
